import type { PatientInsurance } from 'common/interfaces/patientInsurance';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import type { IProcess } from '../../../../../../common/interfaces/IProcess';
import type { IReduxState } from '../../../../../configureStore';
import { ServiceCode } from '../../../../../../common/enums/ServiceCode';
import { fetchJson } from '../../../../../store/fetch';
import { PageTitle } from '../../../../elements/atoms/pageTitle/PageTitle';
import { PageWrapperWithHeader } from '../../../../elements/organisms/pageWrapper/PageWrapperWithHeader';
import { InvoicingContractedCare } from './InvoicingContractedCare';
import { InvoicingNotInsured } from './InvoicingNotInsured';
import { InvoicingNotContractedCare } from './InvoincingNotContractedCare';

export function OsasInvoicingInformation() {
    const patientActiveInsurance = useSelector((state: IReduxState) => state.authentication.insurance);
    const processes = useSelector((state: IReduxState) => state.authentication.processes);
    const osasProcess = processes?.find((process: IProcess) => process.service.code === ServiceCode.OSAS);
    const [patientInsurance, setPatientInsurance] = useState<PatientInsurance>();

    useEffect(() => {
        if (osasProcess) {
            loadPatientInsurance(osasProcess.service.id);
        }
    }, []);

    if (!osasProcess || !patientInsurance) {
        return <></>;
    }

    return (
        <PageWrapperWithHeader>
            <PageTitle>Rekening / factuur</PageTitle>
            {getInsuranceInformation()}
        </PageWrapperWithHeader>
    );

    function getInsuranceInformation() {
        if (!patientInsurance) {
            return <></>;
        }

        if (patientInsurance.hasContractedCare && patientInsurance.isInsured) {
            return <InvoicingContractedCare insurerName={patientActiveInsurance?.uzovi?.name} />;
        }

        if (!patientInsurance.hasContractedCare && patientInsurance.isInsured) {
            return <InvoicingNotContractedCare insurerName={patientActiveInsurance?.uzovi?.name} />;
        }

        if (!patientInsurance.isInsured) {
            return <InvoicingNotInsured />;
        }
    }

    async function loadPatientInsurance(serviceId: string) {
        const result = await fetchJson(`/api/patient/hasContractedCareForService/${serviceId}`, 'GET');

        if (result.json) {
            setPatientInsurance(result.json.insurance);
        }
    }
}
